import { Link } from 'react-router-dom';

export default function FaqHero() {
  return (
    <section className="relative min-h-[56vh] flex items-center overflow-hidden bg-[#F8F5F0]">
      {/* Right image */}
      <div className="absolute top-0 right-0 w-[46%] h-full hidden lg:block">
        <img
          src="https://readdy.ai/api/search-image?query=professional%20advisor%20explaining%20insurance%20documents%20to%20client%20warm%20office%20natural%20light%20calm%20trustworthy%20educational%20consultation%20minimal%20clean&width=900&height=700&seq=faqhero001&orientation=squarish"
          alt="常見問答 保險建築師"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#F8F5F0] via-[#F8F5F0]/55 to-transparent"></div>
      </div>

      <div
        className="absolute inset-0 opacity-[0.04]"
        style={{ backgroundImage: 'radial-gradient(#5C5470 1px, transparent 1px)', backgroundSize: '24px 24px' }}
      ></div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 lg:px-10 pt-28 pb-20">
        <div className="max-w-[560px]">
          <div className="inline-flex items-center gap-2 bg-[#5C5470]/10 border border-[#5C5470]/20 rounded-full px-4 py-2 mb-8">
            <span className="w-2 h-2 rounded-full bg-[#D4A373]"></span>
            <span className="text-[#5C5470] font-medium" style={{ fontSize: '1rem' }}>保險常見問題解答</span>
          </div>

          <h1
            className="font-serif font-bold text-[#5C5470] mb-6"
            style={{ fontSize: 'clamp(2rem, 4vw, 2.75rem)', lineHeight: '1.3' }}
          >
            常見問答
            <br />
            <span className="text-[#D4A373]">把保險問題，</span>
            <br />
            用聽得懂的方式說清楚
          </h1>

          <p
            className="text-[#5C5470]/75 mb-10"
            style={{ fontSize: '1.1875rem', lineHeight: '1.75' }}
          >
            整理醫療、壽險、退休、理賠、保單健檢等常見問題，
            協助您在諮詢前先建立基本判斷。
          </p>

          <div className="flex flex-col sm:flex-row gap-4">
            <Link
              to="/contact"
              className="inline-flex items-center justify-center gap-2 bg-[#D4A373] text-white px-8 py-4 rounded-full font-semibold whitespace-nowrap hover:bg-[#c4935f] transition-all duration-200 hover:scale-105"
              style={{ fontSize: '1.1875rem' }}
            >
              <i className="ri-calendar-check-line"></i>
              預約諮詢
            </Link>
            <Link
              to="/knowledge"
              className="inline-flex items-center justify-center gap-2 border-2 border-[#5C5470] text-[#5C5470] px-8 py-4 rounded-full font-semibold whitespace-nowrap hover:bg-[#5C5470] hover:text-white transition-all duration-200"
              style={{ fontSize: '1.1875rem' }}
            >
              <i className="ri-article-line"></i>
              閱讀知識文章
            </Link>
          </div>

          <div className="mt-12 lg:hidden rounded-2xl overflow-hidden aspect-[16/9]">
            <img
              src="https://readdy.ai/api/search-image?query=professional%20advisor%20explaining%20insurance%20documents%20to%20client%20warm%20office%20natural%20light%20calm%20trustworthy%20educational%20consultation%20minimal%20clean&width=800&height=450&seq=faqhero002&orientation=landscape"
              alt="常見問答"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
